import {useDispatch, useSelector} from 'react-redux';


import type {AppState} from './typedef';
import type {ApiDispatchForToolkit} from '../openapi/admin/types';
import type {TypedUseSelectorHook} from 'react-redux';


export const useAppDispatch = () => useDispatch<ApiDispatchForToolkit>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
